/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Checkbox.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-checkbox");
var checkboxChangeHandler = function (callback) { return function (event) {
    if (callback) {
        callback(event, event.target.checked);
    }
    event.target.blur();
}; };
exports.Checkbox = function Checkbox(_a) {
    var id = _a.id, name = _a.name, checked = _a.checked, onChange = _a.onChange, onClick = _a.onClick, disabled = _a.disabled, hasWarning = _a.hasWarning, children = _a.children, withMargin = _a.withMargin, className = _a.className;
    return (React.createElement("label", { className: classnames(moduleClassName(), withMargin && moduleClassName("withMargin"), hasWarning && moduleClassName("hasWarning"), checked === undefined && moduleClassName("isIndeterminate"), className), onClick: onClick, htmlFor: id },
        React.createElement("input", { type: "checkbox", className: moduleClassName("input"), onChange: checkboxChangeHandler(onChange), id: id, disabled: disabled, name: name, checked: checked === undefined ? false : checked }),
        React.createElement("div", { className: moduleClassName("inputIcon") },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, checked === undefined ? (React.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M4,8 L12.5,8" })) : (React.createElement("polyline", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2.5", points: "3 8.684 6.176 12 13 5" })))),
        !!children && (React.createElement("span", { className: moduleClassName("label") }, children))));
};
exports.Checkbox.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    hasWarning: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    className: PropTypes.string
};